export default {
  SkidDrill: 1,
  FlyDrill: 2
};